export const AUTHN_CONFIG = {
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [
        'REQUIRES_LOWERCASE',
        'REQUIRES_NUMBERS',
        'REQUIRES_SYMBOLS',
        'REQUIRES_UPPERCASE'
      ]
    },
    Auth: {
      region: process.env.REACT_APP_AUTH_REGION,
      userPoolId: process.env.REACT_APP_AUTH_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_AUTH_APP_CLIENT_ID,
      mandatorySignIn: process.env.REACT_APP_AUTH_MANDATORY_SIGNIN === 'true',
      authenticationFlowType: process.env.REACT_APP_AUTH_AUTH_FLOW_TYPE,
      cookieStorage: {
        // REQUIRED - Cookie domain (only required if cookieStorage is provided)
        domain: process.env.REACT_APP_AUTH_COOKIESTORAGE_DOMAIN,
        // OPTIONAL - Cookie path
        path: process.env.REACT_APP_AUTH_COOKIESTRAGE_PATH,
        // OPTIONAL - Cookie expiration in days
        expires: parseInt(process.env.REACT_APP_AUTH_COOKIESTORAGE_EXPIRES),
        // OPTIONAL - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
        sameSite: process.env.REACT_APP_AUTH_COOKIESTORAGE_SAMESITE,
        // OPTIONAL - Cookie secure flag
        // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
        secure: process.env.REACT_APP_AUTH_COOKIESTORAGE_SECURE === 'true'
      },
      oauth: {
        domain: process.env.REACT_APP_AUTH_OAUTH_DOMAIN,
        scope: process.env.REACT_APP_AUTH_OAUTH_SCOPE_LIST.split(','),
        redirectSignIn: process.env.REACT_APP_AUTH_OAUTH_REDIRECT_SIGNIN,
        redirectSignOut: process.env.REACT_APP_AUTH_OAUTH_REDIRECT_SIGNOUT,
        clientId: process.env.REACT_APP_AUTH_APP_CLIENT_ID,
        responseType: process.env.REACT_APP_AUTH_OAUTH_RESPONSE_TYPE,
        providers:  process.env.REACT_APP_AUTH_OAUTH_SOCIAL_PROVIDERS.split(','),
      }
    }, 
    Analytics: {
        disabled: true
    }
};
